export const adfoxOptions = {
    main: {
        ir1: {
            blockId: "R-A-1598227-173",
            renderTo: "yandex_rtb_R-A-1598227-173",
        },
        ir2: {
            blockId: "R-A-1598227-174",
            renderTo: "yandex_rtb_R-A-1598227-174",
        },
        ir3: {
            blockId: "R-A-1598227-175",
            renderTo: "yandex_rtb_R-A-1598227-175",
        },
        ir4: {
            blockId: "R-A-1598227-176",
            renderTo: "yandex_rtb_R-A-1598227-176",
        },
    },
};
